import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const groups = [
  {
    title: "Platform",
    links: [
      { to: "/", label: "Home" },
      { to: "/about", label: "About" },
      { to: "/benefits", label: "Benefits" },
      { to: "/pricing", label: "Pricing · Coming soon" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "App",
    links: [
      { to: "/dashboard", label: "Dashboard" },
      { to: "/devices", label: "Devices" },
      { to: "/history", label: "History" },
      { to: "/notifications", label: "Notifications" },
      { to: "/alerts", label: "Alerts" },
    ],
  },
  {
    title: "Account",
    links: [
      { to: "/login", label: "Login" },
      { to: "/profile", label: "Profile" },
      { to: "/settings", label: "Settings" },
      { to: "/future-updates", label: "Roadmap" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
    ],
  },
];

function Logo({ variant = "dark" }) {
  return (
    <Link to="/" className="flex items-center gap-3 group">
      <div className="relative h-16 w-full max-w-max shrink-0 overflow-hidden">
        <img src="/Images/New Logo.svg" alt="Smart Farming" className="h-full w-full p-1" />
      </div>

    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="relative bg-primary text-cream overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 pt-10 pb-20 sm:pt-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Logo variant="light" />
            <p className="mt-6 text-cream/70 text-sm leading-relaxed max-w-sm">
              Soil moisture, air temperature, and humidity, plus pump control, for small plots. Based in Noida.
            </p>
            <div className="mt-6 space-y-2.5 text-sm text-cream/80">
              <a href="mailto:arayanantal18@gmail.com" className="flex items-center gap-3 hover:text-accent transition-colors">
                <Mail className="h-4 w-4" /> arayanantal18@gmail.com
              </a>
              <a href="tel:+918864994444" className="flex items-center gap-3 hover:text-accent transition-colors">
                <Phone className="h-4 w-4" /> +91 88649 94444
              </a>
              <div className="flex items-center gap-3">
                <MapPin className="h-4 w-4" /> Noida, India
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {groups.map((g) => (
              <div key={g.title}>
                <div className="text-[10px] uppercase tracking-[0.22em] text-accent mb-4 font-medium">{g.title}</div>
                <ul className="space-y-2.5">
                  {g.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="text-sm text-white hover:text-cream underline-grow">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-cream/50">© {new Date().getFullYear()} Smart Farming. All rights reserved.</p>
          <p className="text-xs text-cream/50 font-mono">v1.0</p>
        </div>
      </div>
    </footer>
  );
}

